var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "p-4 bg-white border border-grey-200 rounded",
      attrs: { id: "recommendation-input" }
    },
    [
      _c("div", { staticClass: "space-y-1 mb-4" }, [
        _c(
          "div",
          { staticClass: "text-grey" },
          [
            _c("BlTextSubtitle2", { attrs: { text: "Passing" } }),
            _vm._v(" "),
            _c(
              "span",
              {
                class: {
                  "text-light-purple hover:text-dark-purple-100 cursor-pointer relative":
                    _vm.navigateSuccessMetric
                }
              },
              [
                _c("BlTextSubtitle2", {
                  class: { "underline ": _vm.navigateSuccessMetric },
                  attrs: { text: "success metric" }
                }),
                _vm._v(" "),
                _vm.navigateSuccessMetric
                  ? _c("BlTextSubtitle2", {
                      staticClass: "absolute -right-4 bottom-0 font-normal",
                      attrs: { text: "⮥" }
                    })
                  : _vm._e()
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "text-sm text-grey-400 flex items-center gap-2" },
          [
            _c("BlTextBody2", {
              attrs: { text: "Updating the current target's status from" }
            }),
            _vm._v(" "),
            _c("StatusChip", { attrs: { status: "in_progress", dense: "" } }),
            _vm._v(" "),
            _c("BlTextBody2", { attrs: { text: "to" } }),
            _vm._v(" "),
            _c("StatusChip", { attrs: { status: "mastered", dense: "" } })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "pl-8 space-y-4" }, [
        _c("div", { staticClass: "space-y-1" }, [
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("BlInputToggle", {
                class: { "opacity-75": _vm.totalSuccessChecked },
                attrs: { checked: _vm.totalSuccessChecked },
                on: {
                  changed: function($event) {
                    return _vm.onChangeToggle({
                      totalSuccessChecked: !_vm.totalSuccessChecked,
                      consecutiveSuccessChecked: _vm.consecutiveSuccessChecked
                    })
                  }
                }
              }),
              _vm._v(" "),
              _c("BlTextSubtitle2", {
                staticClass: "text-sm text-grey",
                attrs: { text: "Total success" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center flex-wrap gap-x-1" },
            [
              _c("BlTextBody2", {
                attrs: { text: "Receive a recommendation after completing" }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "font-bold",
                attrs: { text: "at least" }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.totalSuccessInput,
                    expression: "totalSuccessInput"
                  }
                ],
                staticClass:
                  "px-2 text-center rounded border border-grey-200 text-grey h-8 w-10 outline-none focus:border-light-purple",
                class: { "opacity-50": !_vm.totalSuccessChecked },
                attrs: {
                  type: "number",
                  min: "1",
                  disabled: !_vm.totalSuccessChecked
                },
                domProps: { value: _vm.totalSuccessInput },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.totalSuccessInput = $event.target.value
                    },
                    _vm.onInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("BlTextBody2", { attrs: { text: "successful session(s)." } })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "space-y-1" }, [
          _c(
            "div",
            { staticClass: "flex items-center gap-2" },
            [
              _c("BlInputToggle", {
                class: { "opacity-75": _vm.consecutiveSuccessChecked },
                attrs: { checked: _vm.consecutiveSuccessChecked },
                on: {
                  changed: function($event) {
                    return _vm.onChangeToggle({
                      consecutiveSuccessChecked: !_vm.consecutiveSuccessChecked,
                      totalSuccessChecked: _vm.totalSuccessChecked
                    })
                  }
                }
              }),
              _vm._v(" "),
              _c("BlTextSubtitle2", {
                staticClass: "text-sm text-grey",
                attrs: { text: "Consecutive success" }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex items-center flex-wrap gap-x-1 text-sm" },
            [
              _c("BlTextBody2", {
                attrs: {
                  text:
                    "Receive a recommendation only if the session is successful for"
                }
              }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.consecutiveSuccessInput,
                    expression: "consecutiveSuccessInput"
                  }
                ],
                staticClass:
                  "px-2 text-center rounded border border-grey-200 text-grey h-8 w-10 outline-none focus:border-light-purple",
                class: !_vm.consecutiveSuccessChecked ? "opacity-50" : "",
                attrs: {
                  type: "number",
                  min: "2",
                  disabled: !_vm.consecutiveSuccessChecked
                },
                domProps: { value: _vm.consecutiveSuccessInput },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.consecutiveSuccessInput = $event.target.value
                    },
                    _vm.onInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("BlTextBody2", {
                staticClass: "font-bold",
                attrs: { text: "consecutive session(s)." }
              })
            ],
            1
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-425bc2f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-425bc2f2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/modal/ActionRecommendationInput.vue
// module id = null
// module chunks = 